import React from "react";
import { Grid, Table } from "semantic-ui-react";
import AttendanceFormatSy from "../../data/attendance-format-sy.json";

const DynamicAttendanceComponent = ({ 
  attendance, 
  daysOfSchool, 
  schoolYear 
}) => {
  // Month configurations
  const MONTHS = [
    { key: 'jan', label: 'JAN', name: 'January' },
    { key: 'feb', label: 'FEB', name: 'February' },
    { key: 'mar', label: 'MAR', name: 'March' },
    { key: 'apr', label: 'APR', name: 'April' },
    { key: 'may', label: 'MAY', name: 'May' },
    { key: 'jun', label: 'JUN', name: 'June' },
    { key: 'jul', label: 'JUL', name: 'July' },
    { key: 'aug', label: 'AUG', name: 'August' },
    { key: 'sep', label: 'SEP', name: 'September' },
    { key: 'oct', label: 'OCT', name: 'October' },
    { key: 'nov', label: 'NOV', name: 'November' },
    { key: 'dec', label: 'DEC', name: 'December' }
  ];

  // Function to get ordered months starting from the school year start month
  const getOrderedMonths = (startMonth) => {
    const startIndex = MONTHS.findIndex(month => month.label === startMonth);
    if (startIndex === -1) {
      console.warn(`Start month ${startMonth} not found, defaulting to July`);
      return MONTHS.slice(6).concat(MONTHS.slice(0, 6)); // Default to July start
    }
    
    return MONTHS.slice(startIndex).concat(MONTHS.slice(0, startIndex));
  };

  // Get the ordered months based on school year configuration
  const getSchoolYearConfig = () => {
    if (schoolYear && schoolYear.name) {
      const config = AttendanceFormatSy.find(sy => sy.name === schoolYear.name);
      return config || { startMonth: 'JUL' }; // Default to July if not found
    }
    return { startMonth: 'JUL' }; // Default to July if no school year
  };

  const schoolYearConfig = getSchoolYearConfig();
  const orderedMonths = getOrderedMonths(schoolYearConfig.startMonth);

  // Helper function to safely get values from objects
  const getValue = (obj, key, suffix = '') => {
    const fullKey = key + suffix;
    return obj && obj[fullKey] !== undefined ? obj[fullKey] : '';
  };

  // Example of how tardy data is structured in your attendance object:
  // attendance = {
  //   jul: 20, aug: 22, sep: 18, ... (days present)
  //   julTardy: 2, augTardy: 1, sepTardy: 3, ... (times tardy)
  //   total: 180, totalTardy: 15
  // }

  return (
    <Grid.Row>
      <Grid.Column width={16}>
        <Table celled compact size="small">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="center">
                ATTENDANCE
              </Table.HeaderCell>
              {orderedMonths.map(month => (
                <Table.HeaderCell key={month.key} textAlign="center">
                  {month.label}
                </Table.HeaderCell>
              ))}
              <Table.HeaderCell textAlign="center">
                TOTAL
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {attendance != null ? (
              <React.Fragment>
                <Table.Row>
                  <Table.Cell
                    className="attendance-table-cell-sample"
                    textAlign="center"
                    collapsing
                  >
                    Days of School
                  </Table.Cell>
                  {orderedMonths.map(month => (
                    <Table.Cell
                      key={month.key}
                      className="attendance-table-cell-sample"
                      textAlign="center"
                      collapsing
                    >
                      {getValue(daysOfSchool, month.key, 'Days')}
                    </Table.Cell>
                  ))}
                  <Table.Cell
                    className="attendance-table-cell-sample"
                    textAlign="center"
                    collapsing
                  >
                    {getValue(daysOfSchool, 'total', 'Days')}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell
                    className="attendance-table-cell-sample"
                    textAlign="center"
                    collapsing
                  >
                    Days Present
                  </Table.Cell>
                  {orderedMonths.map(month => (
                    <Table.Cell
                      key={month.key}
                      className="attendance-table-cell-sample"
                      textAlign="center"
                      collapsing
                    >
                      {getValue(attendance, month.key)}
                    </Table.Cell>
                  ))}
                  <Table.Cell
                    className="attendance-table-cell-sample"
                    textAlign="center"
                    collapsing
                  >
                    {getValue(attendance, 'total')}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell
                    className="attendance-table-cell-sample"
                    textAlign="center"
                    collapsing
                  >
                    Times Tardy
                  </Table.Cell>
                  {orderedMonths.map(month => (
                    <Table.Cell
                      key={month.key}
                      className="attendance-table-cell-sample"
                      textAlign="center"
                      collapsing
                    >
                      {getValue(attendance, month.key, 'Tardy')}
                    </Table.Cell>
                  ))}
                  <Table.Cell
                    className="attendance-table-cell-sample"
                    textAlign="center"
                    collapsing
                  >
                    {getValue(attendance, 'total', 'Tardy')}
                  </Table.Cell>
                </Table.Row>
              </React.Fragment>
            ) : (
              <Table.Row>
                <Table.Cell
                  textAlign="center"
                  colSpan={14}
                  style={{ color: "gray" }}
                >
                  <em>Attendance not yet available</em>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </Grid.Column>
    </Grid.Row>
  );
};

export default DynamicAttendanceComponent;